import React from 'react';

const SRC = `${process.env.REACT_APP_BACKEND_URL}/api/company-profile/email-logo.png`;

// The trimmed logo actually used in customer emails (175px) and PDFs (about 2.35in), shown at those sizes.
export const LogoInUse = ({ url, testId = 'logo-in-use' }) => {
  if (!url) return null;
  const src = `${SRC}?v=${encodeURIComponent(url)}`;
  return (
    <div className="flex flex-wrap items-end gap-6" data-testid={testId}>
      <figure className="space-y-1">
        <div className="bg-white border rounded-md px-6 py-4 flex items-center justify-center">
          <img src={src} alt="Logo as used in emails" style={{ width: 175, height: 'auto' }} data-testid={`${testId}-email`} />
        </div>
        <figcaption className="text-[11px] text-neutral-500">Email header · actual size</figcaption>
      </figure>
      <figure className="space-y-1">
        <div className="bg-white border rounded-md px-6 py-4 flex items-center justify-center">
          <img src={src} alt="Logo as used on PDFs" style={{ width: 226, height: 'auto' }} data-testid={`${testId}-pdf`} />
        </div>
        <figcaption className="text-[11px] text-neutral-500">PDF letterhead · on-screen size</figcaption>
      </figure>
    </div>
  );
};
